@if(!listing){
<div class="bg-col-1"
     [toggleClass]="'none-s none-m'"
     [toggleClassBy]="toggleService.getState(uid)">
    <div class="wrap _no-padding-right _no-padding-left"
         [grid]="[1, 1, 2, 2][client.sizeId]"
         [gridRowGap]="'24px'"
         [gridColumnGap]="0">
        <div class="p-t-10 p-t-8-s p-t-8-m p-b-12-x p-b-12-l m-r-5-x m-r-5-l _start-step-text-content">
            <h2 class="h1 col-w"
                *iCms="'title' of component"></h2>
            <div class="m-t-8 m-t-6-s m-t-6-m w-12">
                <p class="p1 col-w"
                   *iCms="'subtitle' of component"></p>
                <button class="m-t-8 m-t-6-s m-t-6-m"
                        [buttonStyle]
                        (click)="toggleService.toggle([uid, currentStep()])">
                    <span *iCms="'buttonLabel' of component"></span>
                </button>
            </div>
        </div>
        <img class="block w-12 _start-step-image"
             [dfImage]="component.image">
    </div>
</div>
<div [toggleClass]="'!none-s !none-m'"
     [toggleClassBy]="toggleService.getState(uid)">
    <div class="pos-absolute-x pos-absolute-l wrap _steps p-t-10 p-b-10 p-t-8-s p-b-8-s p-t-8-m p-b-8-m"
         [class._no-padding-right]="client.sizeId > 1"
         [toggleClass]="'_visible !none-s !none-m'"
         [toggleClassBy]="toggleService.getState(uid)"
         [grid]="[1, 1, 2, 2][client.sizeId]"
         [gridRowGap]="'24px'"
         [gridColumnGap]="0">
        @if(client.sizeId > 1){
        <ng-container [ngTemplateOutlet]="titleAndImage" />
        }@else{
        <h2 class="h1 col-w m-r-10-x m-r-10-l"
            *iCms="'title' of component"></h2>
        }
        <div class="_question w-12 flex-column flex-justify-center pos-relative p-r-0-s p-r-0-m">
            <ng-form class="m-t-5-x m-t-5-l"
                     #form="ngForm">
                @for(step of component.steps; track step){
                <div [toggleClass]="'!none'"
                     [toggleClassBy]="toggleService.getState([uid, $index])">
                    <h3 class="h3 h4-s h4-m col-w"
                        *iCms="'text' of step"></h3>
                    <radio-group class="_form-step m-t-5 m-t-6-s m-t-6-m"
                                 [name]="step.attribute"
                                 [required]="!step.dependsOn || step.dependsOn && toggleService.isOpen([uid, $index])"
                                 [model]="formModels.get(step)"
                                 (modelChange)="formModelChange(step, $event)">
                        @for(answer of step.answers; track answer){
                        <radio-group-item class="col-1 _radio bg-col-4 bg-col-52-s bg-col-52-m p-a-2"
                                          [class.m-t-3]="!$first"
                                          [value]="answer.value">
                            <span *iCms="'text' of answer"></span>
                        </radio-group-item>
                        }
                    </radio-group>
                    <div class="m-t-5 _buttons flex">
                        @if($index !== 0){
                        <button [buttonStyle]="'button-2'"
                                (click)="goToPreviousStep()">
                            {{'back' | translate}}
                        </button>
                        }
                        @if($index !== component.steps?.length-1){
                        <button [buttonStyle]
                                (click)="goToNextStep()"
                                [disabled]="!isStepValid($index)">
                            {{'next question' | translate}}
                        </button>
                        }@else {
                        <button [buttonStyle]
                                (click)="seeResults()"
                                [disabled]="!form.valid"
                                [busy]="resultButtonBusy()">
                            {{'see results' | translate}}
                        </button>
                        }
                    </div>
                </div>
                }
            </ng-form>
            <steps-bar class="pos-absolute-x pos-absolute-l _steps-bar m-t-6-s m-t-6-m"
                       [totalSteps]="quizProgress.total"
                       [currentStep]="quizProgress.current" />
        </div>
        @if(2 > client.sizeId){
        <div class="_image ratio-1-1 w-12">
            <img class="rf"
                 [dfImage]="component.stepsImage">
        </div>
        }
    </div>
</div>
}
@else{
<product-listing [listing]="listing" />
}
<ng-template #titleAndImage>
    <div class="m-r-10-x m-r-10-l">
        <h2 class="h1 col-w"
            *iCms="'title' of component"></h2>
        <img class="block m-t-10 w-12 _image _title-image"
             [dfImage]="component.stepsImage">
    </div>
</ng-template>